import React, { useEffect } from 'react';
import { EmptyState } from '../../../../../components/EmptyState';
import { BackToCareersPageButton } from '../BackToCareersPageButton';
import OlderInterviewWoman from '../../../../../images/older_interview_woman_image.png';
import ahoy from 'ahoy.js';
import { CareerAnalyticsEventType } from '../../../../../enums/ClickEvents/CareerAnalyticsEventType';

interface PropTypes {
  organizationId: number;
  jobPostId: number;
  atsCaptureEventsAhoy: boolean;
}

export default function ErrorPage(props: PropTypes) {
  useEffect(() => {
    if (props.atsCaptureEventsAhoy) {
      ahoy.track(CareerAnalyticsEventType.ApplicationErrorView, {
        organization_id: props.organizationId,
        applicant_tracking_job_post_id: props.jobPostId,
      });
    }
  }, []);

  return (
    <EmptyState
      title={'Your application was not submitted'}
      text={'Your application was not successful. Please try again.'}
      cardless
      isResponsive
      imageSrc={OlderInterviewWoman}
      actionButton={
        <BackToCareersPageButton
          color={'primary'}
          size={'md'}
          className={'mt-4'}
          isResponsive
          onClick={() => (window.location.href = '../../..')}
        />
      }
    />
  );
}
